import { FormGroup } from "@angular/forms";
import { disabledIntegration } from "./nexsys-form-config.model";
import { ValidationContext } from "@cv-invision/cv.invision-views.ux";
import { IntegrationConfig } from "./product.model";

export const XPANSE_FORM_CONFIG = {
	xpanse: {
		enabled: {
			path: 'xpanse.enabled',
			DataType: 'Boolean',
			DisplayText: `Xpanse`,
			Name: 'enabled',
			customClass: 'product-form-switch',
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					disabledIntegration(formGroup);
					formGroup.get('xpanse')?.setValue(new IntegrationConfig());
					formGroup.get('xpanse.enabled')?.setValue($event.checked);
					formGroup.get('xpanse').updateValueAndValidity();
				},
			},
		},
		isDefaultProduct: {
			path: 'xpanse.isDefaultProduct',
			DataType: 'Boolean',
			DisplayText: `Default Product Configuration`,
			Name: 'isDefaultProduct',
			customClass: 'product-form-switch ms-5',
			required:false,
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					formGroup.get('xpanse.productId')?.setValue(null);
					formGroup.get('xpanse.productName')?.setValue(null);

					if ($event.checked) {
						formGroup.get('isOrganizationLevel')?.setValue(false);
						formGroup.get('xpanse.productId')?.setValue('unknown');
						formGroup.get('xpanse.productName')?.setValue(null);
					}

					formGroup.get('xpanse').updateValueAndValidity();
				},
			},
		},
		productId: {
			DataType: 'Selector',
			path: 'xpanse.productId',
			UIControl: 'Dropdown',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productId',
			customClass: 'product-form-dropdown',
			options: [],
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			isRequired: function(control, jsonModelService: ValidationContext) {
				return jsonModelService.IsEmpty() && (jsonModelService.FindValue('isDefaultProduct') === false ) && jsonModelService.FindValue('enabled');
			},
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexOption = formConfigModel.options.findIndex(element => element.value === value);
						const option = formConfigModel.options[ indexOption ];
						formGroup.get('integration.productName')?.setValue(option?.label);
					} else {
						formGroup.get('integration.productId')?.setValue(null);
						formGroup.get('integration.productName')?.setValue(null);
					}
				},
			},
		},
		productName: {
			DataType: 'String',
			path: 'xpanse.productName',
			DisplayText: 'Product Name',
			label: 'Product Name',
			Name: 'productName',
			required: false,
			hidden: true,
		},
		isFhaProduct: {
			path: 'xpanse.isFhaProduct',
			DataType: 'Boolean',
			DisplayText: `Is a FHA Product`,
			Name: 'isFhaProduct',
			customClass: 'product-form-switch ms-5',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			}
		},
		isOrderIncomeStatement: {
			path: 'xpanse.isOrderIncomeStatement',
			DataType: 'Boolean',
			DisplayText: `Is Order Income Statement`,
			Name: 'isOrderIncomeStatement',
			customClass: 'product-form-switch  ms-3',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			}
		},
		isOrderRentSchedule: {
			path: 'xpanse.isOrderRentSchedule',
			DataType: 'Boolean',
			DisplayText: `Is Order Rent Schedule`,
			Name: 'isOrderRentSchedule',
			customClass: 'product-form-switch  ms-3',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isDefaultProduct');
				return (optionSelected === false) || false;

			}
		},
		defaultFhaNumber: {
			path: 'xpanse.defaultFhaNumber',
			DataType: 'String',
			DisplayText: `Default FHA Number`,
			Name: 'defaultFhaNumber',
			customClass: '',
			required: false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const optionSelected = jsonModelService.FindValue('isFhaProduct');
				return optionSelected || false;

			}
		}
	}
}
